import apiWorker from '../apiWorker'

const credit_events = {
    search : (company_id, data) =>  apiWorker('post', `/v1/admin/${company_id}/credit_events`, data),
    check     : (contact_id, type)  => apiWorker('get', `/v1/billing/credit_events/check/${contact_id}/${type}`),
    refund : (data)             =>  apiWorker('post', `/v1/admin/credit_events/refund`, data),
}

export default credit_events;